/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationKeyFigureValue } from './SimulationKeyFigureValue';
import {
    SimulationKeyFigureValueFromJSON,
    SimulationKeyFigureValueFromJSONTyped,
    SimulationKeyFigureValueToJSON,
    SimulationKeyFigureValueToJSONTyped,
} from './SimulationKeyFigureValue';

/**
 * 
 * @export
 * @interface SimulationKeyFigureRequestItem
 */
export interface SimulationKeyFigureRequestItem {
    /**
     * 
     * @type {number}
     * @memberof SimulationKeyFigureRequestItem
     */
    priceListId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationKeyFigureRequestItem
     */
    priceList: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationKeyFigureRequestItem
     */
    year: number;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    salesRevenue?: SimulationKeyFigureValue;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    listPriceFmcFactor?: SimulationKeyFigureValue;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    lpLocalLeadIndex?: SimulationKeyFigureValue;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    nipLocalLeadIndex?: SimulationKeyFigureValue;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    nipGlobalLeadIndex?: SimulationKeyFigureValue;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    rm?: SimulationKeyFigureValue;
    /**
     * 
     * @type {SimulationKeyFigureValue}
     * @memberof SimulationKeyFigureRequestItem
     */
    rrpIndex?: SimulationKeyFigureValue;
}

/**
 * Check if a given object implements the SimulationKeyFigureRequestItem interface.
 */
export function instanceOfSimulationKeyFigureRequestItem(value: object): value is SimulationKeyFigureRequestItem {
    if (!('priceListId' in value) || value['priceListId'] === undefined) return false;
    if (!('priceList' in value) || value['priceList'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    return true;
}

export function SimulationKeyFigureRequestItemFromJSON(json: any): SimulationKeyFigureRequestItem {
    return SimulationKeyFigureRequestItemFromJSONTyped(json, false);
}

export function SimulationKeyFigureRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationKeyFigureRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'priceListId': json['priceListId'],
        'priceList': json['priceList'],
        'year': json['year'],
        'salesRevenue': json['salesRevenue'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['salesRevenue']),
        'listPriceFmcFactor': json['listPriceFmcFactor'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['listPriceFmcFactor']),
        'lpLocalLeadIndex': json['lpLocalLeadIndex'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['lpLocalLeadIndex']),
        'nipLocalLeadIndex': json['nipLocalLeadIndex'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['nipLocalLeadIndex']),
        'nipGlobalLeadIndex': json['nipGlobalLeadIndex'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['nipGlobalLeadIndex']),
        'rm': json['rm'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['rm']),
        'rrpIndex': json['rrpIndex'] == null ? undefined : SimulationKeyFigureValueFromJSON(json['rrpIndex']),
    };
}

export function SimulationKeyFigureRequestItemToJSON(json: any): SimulationKeyFigureRequestItem {
    return SimulationKeyFigureRequestItemToJSONTyped(json, false);
}

export function SimulationKeyFigureRequestItemToJSONTyped(value?: SimulationKeyFigureRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceListId': value['priceListId'],
        'priceList': value['priceList'],
        'year': value['year'],
        'salesRevenue': SimulationKeyFigureValueToJSON(value['salesRevenue']),
        'listPriceFmcFactor': SimulationKeyFigureValueToJSON(value['listPriceFmcFactor']),
        'lpLocalLeadIndex': SimulationKeyFigureValueToJSON(value['lpLocalLeadIndex']),
        'nipLocalLeadIndex': SimulationKeyFigureValueToJSON(value['nipLocalLeadIndex']),
        'nipGlobalLeadIndex': SimulationKeyFigureValueToJSON(value['nipGlobalLeadIndex']),
        'rm': SimulationKeyFigureValueToJSON(value['rm']),
        'rrpIndex': SimulationKeyFigureValueToJSON(value['rrpIndex']),
    };
}

